"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrowserDetection = exports.EBrowserTypes = void 0;
const react_1 = require("react");
var EBrowserTypes;
(function (EBrowserTypes) {
    EBrowserTypes["GOOGLE_BOT"] = "googlebot";
    EBrowserTypes["IE"] = "ie";
    EBrowserTypes["EDGE"] = "edge";
    EBrowserTypes["FIREFOX"] = "firefox";
    EBrowserTypes["OPERA"] = "opera";
    EBrowserTypes["CHROME"] = "chrome";
    EBrowserTypes["SAFARI"] = "safari";
    EBrowserTypes["UNKNOWN"] = "unknown";
})(EBrowserTypes || (exports.EBrowserTypes = EBrowserTypes = {}));
const useBrowserDetection = () => {
    const [browserName, setBrowserName] = (0, react_1.useState)(EBrowserTypes.UNKNOWN);
    (0, react_1.useEffect)(() => {
        const isGoogleBot = navigator.userAgent.toLowerCase().indexOf('googlebot') !== -1;
        const isFirefox = navigator.userAgent.indexOf(' Firefox/') !== -1;
        const isOpera = navigator.userAgent.indexOf(' OPR/') >= 0;
        const isChrome = !isGoogleBot &&
            !isOpera &&
            navigator.vendor.toLowerCase().indexOf('google inc.') !== -1;
        const isSafari = !isChrome && navigator.userAgent.toLowerCase().indexOf('safari') !== -1;
        if (isFirefox) {
            setBrowserName(EBrowserTypes.FIREFOX);
        }
        else if (isOpera) {
            setBrowserName(EBrowserTypes.OPERA);
        }
        else if (isChrome) {
            setBrowserName(EBrowserTypes.CHROME);
        }
        else if (isSafari) {
            setBrowserName(EBrowserTypes.SAFARI);
        }
        else if (isGoogleBot) {
            setBrowserName(EBrowserTypes.GOOGLE_BOT);
        }
    }, []);
    return browserName;
};
exports.useBrowserDetection = useBrowserDetection;
//# sourceMappingURL=useBrowserDetection.js.map